import { useEffect, useState } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { FileData } from "../../detail/components/dataFile/types"
import { ObjectGeneric } from "../../../../../utils/types/generals"
import { getLocalStorage } from "../../../../../utils/crud/crypt"
import { RequestErrors, Status, Types } from "../../../../../utils/enums"
import { EditViewNavigate } from "../../../utils/enums/menu"
import { UserCreator } from "../../detail/components/file/types"
import { filesManagerServiceFetch } from "../../../../../utils/constants/callService"
import { formatFileDetail } from "../../../../../service/filesManager/format"
import { updateFileBody, updatePermisisonBody } from "../../../../../service/filesManager/body"
import { handleAllErrors } from "../../../../../utils/methods/handleErrors"
import { SolicitedUserRow } from "../../createFile/components/step1/types"
import { Box, Checkbox } from "@mui/material"
import { useStyles } from "../styles"
import { returnQuery } from "../../../../../utils/methods/returnQuery"
import { FilterBody } from "../../../../../hooks/filter/typing"

const useBody = ({ userFolioSelected, userFilter }: { userFilter: FilterBody, userFolioSelected: Record<string, { seeFile?: boolean; downloadFile?: boolean; }> }) => {

    const navigate = useNavigate()
    const styles = useStyles()
    const location = useLocation();
    const option: EditViewNavigate = location.state?.option;
    const { id: fileId } = useParams()
    const { t } = useTranslation()
    const [file, setFile] = useState<FileData | File>({ createDate: '', editDate: '', name: '', size: '', type: '', url: '' })
    const [keyFile, setKeyFile] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({})
    const [data, setData] = useState<ObjectGeneric>({})
    const [solictedUser, setSolicitedUsers] = useState<{ id: number; name: string }[]>([])
    const [solictedUserCopy, setSolicitedUsersCopy] = useState<{ id: number; name: string }[]>([])
    const [isLoadingTable, setIsLoadingTable] = useState(false)
    const [requestingUsers, setRequestingUsers] = useState<number[]>([])
    const [requesUserCopy, setRequesUserCopy] = useState<number[]>([])
    const [userCreator, setUserCreator] = useState<UserCreator>({ area: [], department: [], name: '', role: '', userType: '' })
    const [loadingDetail, setLoadingDetail] = useState(false)
    const [statusFile, setStatusFile] = useState(Status.ACTIVE)
    const state: { id: number, role: number } = getLocalStorage()
    const [canDownload, setCanDownload] = useState(false)
    const [canSee, setCanSee] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const [loadingPermission, setLoadinPermission] = useState(false)
    const [row, setRow] = useState<SolicitedUserRow[]>([])
    const [checked, setChecked] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const [canSubmitEdit, setCanSubmitEdit] = useState(false)



    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('filesManager.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })

    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const deleteUser = (id: number) => {

        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.deleteThisSolicitedUser'),
            confirm: () => {
                setCanSubmitEdit(true);
                setSolicitedUsers(prevUsers => prevUsers.filter(user => user.id !== id));
                setRequestingUsers(prevUsers => prevUsers.filter(user => user !== id));
                closeModalIndex();
            }
        }))
    }

    const handleCancelPermission = () => {

        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.cancelPermissionConfiguration'),
            confirm: () => {
                if (option == EditViewNavigate.TABLE) {
                    navigate('/dashboard/filesManager/main');
                } else {
                    navigate(`../detail/${fileId}`);
                }
            }
        }))
    }

    const handleSubmitPermission = () => {

        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.confirmation'),
            description: t('filesManager.modal.description.savePermissionConfiguration'),
            confirm: () => {
                closeModalIndex();
                handleEditPermissions();
            }
        }))
    }


    const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value })



    const goBackToList = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: option == EditViewNavigate.TABLE ? t('filesManager.modal.titles.backToList') : t('filesManager.modal.titles.backToDetail'),
            description: option == EditViewNavigate.TABLE ? t('filesManager.modal.description.toBackTheChangesLost') : t('filesManager.modal.description.toBackTheChangesLostDetail'),
            confirm: () => {
                if (option == EditViewNavigate.TABLE) {
                    navigate('/dashboard/filesManager/main');
                } else {
                    navigate(`../detail/${fileId}`);
                }

            }
            //Agregar acá la funcion para eliminar
        }))

    }

    const closeModalIndex = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }


    const handleAddUsersSolicited = () => {
        if (!canSubmitEdit) {
            if (requesUserCopy !== requestingUsers) {
                setCanSubmitEdit(true);
            }
        }
        setRequestingUsers(requesUserCopy)
        setSolicitedUsers(solictedUserCopy);

    }

    const handleShowTable = (value: boolean) => {
        setShowTable(value)
        if (value) {
            setSolicitedUsersCopy(solictedUser)
            setRequesUserCopy(requestingUsers)
        }
    }

    const getFileDatail = async () => {
        setLoadingDetail(true)
        const response = await filesManagerServiceFetch.getFileById({ id: Number(fileId) })

        const { userCreator, solictedUser, status, file, data, canDownload, requestingUsers, key, canSee } = formatFileDetail({ response, userId: state.id, role: state.role })

        setUserCreator(userCreator)
        setSolicitedUsers(solictedUser)
        setStatusFile(status)
        setFile(file)
        setKeyFile(key)
        setData(data)
        setCanDownload(canDownload)
        setCanSee(canSee)
        setRequestingUsers(requestingUsers)

        setLoadingDetail(false)
    }

    const handleEditFile = async () => {
        setLoadingSave(true)
        const formData = updateFileBody({ data: data, file: file, requestingUsers: requestingUsers })
        const response = await filesManagerServiceFetch.updateFile(formData, Number(fileId))
        if (!response.errors) {
            setOpenSnackbar({ ...openSnackbar, open: true, message: t('filesManager.snackbar.updateFile'), type: Types.SUCCESS })
            //getFileDatail()
            setTimeout(() => {
                if (option === EditViewNavigate.TABLE) {
                    navigate('/dashboard/filesManager/main');
                } else {
                    navigate(`../detail/${fileId}`);
                }
            }, 3000);
        } else {
            setOpenSnackbar({ ...openSnackbar, open: true, message: handleAllErrors(response.errors[0].code as RequestErrors, t), type: Types.ERROR })
        }
        setLoadingSave(false)
    }

    const handleEditPermissions = async () => {
        setLoadinPermission(true)
        const body = updatePermisisonBody({ userPermissions: userFolioSelected })
        const response = await filesManagerServiceFetch.updatePermissions({ body, id: Number(fileId) })
        if (!response.errors) {
            setOpenSnackbar({ ...openSnackbar, open: true, message: t('filesManager.snackbar.updatePermissionsUnique'), type: Types.SUCCESS })
            //getFileDatail()
            setTimeout(() => {
                if (option === EditViewNavigate.TABLE) {
                    navigate('/dashboard/filesManager/main');
                } else {
                    navigate(`../detail/${fileId}`);
                }
            }, 3000);
        } else {
            setOpenSnackbar({ ...openSnackbar, open: true, message: handleAllErrors(response.errors[0].code as RequestErrors, t), type: Types.ERROR })
        }
        setLoadinPermission(false)
    }

    const searchUsersSolicited = async ({ all }: { all: boolean }) => {
        try {
            setIsLoadingTable(true)
            const response = await filesManagerServiceFetch.getUsersToAddPermissions({ query: all ? returnQuery(userFilter.query, {}) : '' })
            let allUsers: SolicitedUserRow[] = response?.map(item => ({
                id: item.id,
                fullname: item.fullName && item.fullName.trim() !== "" ? item.fullName : "N/A",
                userType: item.userType ?? '',
                curp: item.curp ?? '',
                email: item.email,
                phone: item.phone
            })) ?? []
            if (!!allUsers?.length) {
                setRow(allUsers)
                const allPresent = allUsers.every(user => requesUserCopy.includes(user.id))

                const allNotPresent = !allPresent

                if (allNotPresent) {
                    setChecked(false)
                } else {
                    setChecked(true)
                }
            } else {
                setRow([])
                setOpenSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
            }
        } catch (e) {
            setRow([])
            setOpenSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
        }
        finally {
            setIsLoadingTable(false)
        }
    }

    const handleSelectUser = ({ id, value, fullName }: { id: string, value: boolean, fullName?: string }) => {
        if (id == 'all') {
            if (value) {
                setRequesUserCopy(prev => {
                    const allIds = row.map(r => r.id)
                    const newIds = allIds.filter(id => !prev.includes(id))
                    return [...prev, ...newIds]
                })

                setSolicitedUsersCopy(prev => {
                    const allUsers = row.map(r => ({ id: r.id, name: r.fullname }))
                    const newUsers = allUsers.filter(u => !prev.some(p => p.id === u.id))
                    return [...prev, ...newUsers]
                })

                setChecked(true)
            } else {
                setRequesUserCopy([])
                setSolicitedUsersCopy([])
                setChecked(false)
            }
        } else {
            const numberId = Number(id)
            if (value) {
                setRequesUserCopy(prev => [...prev, numberId])
                setSolicitedUsersCopy(prev => [...prev, { id: numberId, name: fullName ?? '' }])
            } else {
                setRequesUserCopy(prev => prev.filter(item => item !== numberId))
                setSolicitedUsersCopy(prev => prev.filter(item => item.id !== numberId))
            }
        }
    }

    const column = [
        {
            id: 'actions',
            rowTdStyles: {
                width: '15px',
            },
            headerCell: {
                width: '15px',
            },
            column: () => {
                return (
                    <Box sx={styles.all} >
                        <Checkbox
                            checked={checked}
                            onChange={(_, check) => {
                                handleSelectUser({ id: 'all', value: check })
                            }}
                            color="primary"
                            className="remove-m"
                        />
                    </Box>
                )
            },
            renderCell: (params: any) => {
                const id = params.row.id
                const name = params.row.fullname
                return (
                    <Box sx={styles.all} >
                        <Checkbox
                            checked={requesUserCopy.includes(id)}
                            onChange={(_, check) => {
                                handleSelectUser({ id: id, value: check, fullName: name })
                            }}
                            color="primary"
                        />
                    </Box>
                )
            },
        },
        {
            id: 'fullname',
            label: t('useScheduled.detail.tables.fullname'),
            minWidth: 120,
        },
        {
            id: 'curp',
            label: t('useScheduled.detail.tables.curp'),
            minWidth: 120,
        },
        {
            id: 'userType',
            label: t('useScheduled.detail.tables.userType'),
            minWidth: 120,
        },
        {
            id: 'email',
            label: t('useScheduled.detail.tables.email'),
            minWidth: 120,
        },
        {
            id: 'phone',
            label: t('useScheduled.detail.tables.phone'),
            minWidth: 120,
        },
    ]


    useEffect(() => {
        getFileDatail()
    }, [fileId])


    return {
        goBackToList,
        data,
        errors,
        file,
        setData,
        setErrors,
        setFile,
        status: Status.ACTIVE,
        solictedUser,
        deleteUser,
        isLoadingTable,
        handleAddUsersSolicited,
        modal,
        closeModalIndex,
        handleSubmitPermission,
        handleCancelPermission,
        option,
        fileId,
        userCreator,
        statusFile,
        canDownload,
        loadingDetail,
        handleEditFile,
        loadingSave,
        openSnackbar,
        handleCloseSnackbar,
        handleEditPermissions,
        loadingPermission,
        keyFile,
        canSee,
        row,
        column,
        searchUsersSolicited,
        handleShowTable,
        showTable,
        canSubmitEdit,
        setCanSubmitEdit
    }
}

export { useBody }
